import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, menu, mobileHero, viewMenu } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100VH"
          w="100%"
          image={`url(${mobileHero}) bottom/ cover no-repeat`}
          column
          justifyBetween
          alignCenter
        >
          <Header />
          <CFView
            textCenter
            column
            center
            w="100%"
            ph="10%"
            pt="10px"
            // bg="rgba(0, 0, 0, 0.85)"
            // style={{
            //   backdropFilter: 'blur(10px)',
            //   webkitBackdropFilter: 'blur(10px)',
            // }}
          >
            <CFView pulsate mb="10px">
              <OrderPickupButton />
            </CFView>
            <CFView mb="20px">
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
          zIndex={90}
          column
          justifyBetween
          alignStart
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <Header />
          <CFView
            center
            w="100%"
            pv="5px"
            maxWidth="1400px"
            bg="rgba(0, 0, 0, 0.7)"
            style={{
              backdropFilter: 'blur(10px)',
              webkitBackdropFilter: 'blur(10px)',
            }}
          >
            {/* <CFText
              color="white"
              style={{
                fontSize: 28,
                color: '#BD9200',
              }}
              raleway
              xBold
            >
              NOW TAKING ONLINE ORDERS!
            </CFText> */}
            <CFView pulsate mt="5px">
              <OrderPickupButton />
            </CFView>
            <CFView ml="20px" mt="5px">
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
